
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import InvoiceItemMenu from './InvoiceItemMenu.vue'
import { mapMutations, mapState, mapActions } from 'vuex'
import { SelectedLineItemOption } from '../types/invoice_line_items'
import truncate from 'lodash/truncate'
import helpers from '../../../../../utils/helpers.js'

export default {
  components: {
    NrTooltip,
    NrModal,
    InvoiceItemMenu
  },

  computed: {
    ...mapState('request_show', [
      'totalSelectedLineItems',
      'activeModal',
      'invoiceItemToEdit'
    ]),

    activeItemDeleteModal() {
      return this.activeModal === 'deleteInvoiceItem'
    }
  },

  methods: {
    ...mapActions('request_show', ['recalculateAllCosts']),

    ...mapMutations('request_show', [
      'setInvoiceLineItemType',
      'setInvoiceSelectedLineItem',
      'setInvoiceLineItemQuantity',
      'setInvoiceSelectedSurchargeItem',
      'setInvoiceAddItemModal',
      'setTotalSelectedLineItems',
      'setInvoiceItemToEdit',
      'setActiveModal'
    ]),

    truncate,

    formatCost(amount: number, maximumFractionDigits: number = 2) {
      return helpers.formatCost(amount, maximumFractionDigits)
    },

    onEdit(item: SelectedLineItemOption, index: number): void {
      const lineItem = { ...item, index }
      this.setInvoiceItemToEdit(lineItem)
      this.setInvoiceLineItemType('Line item')
      this.setInvoiceSelectedLineItem(item)
      this.setInvoiceLineItemQuantity(item.total_count)
      this.setInvoiceAddItemModal(true)
    },

    deleteInvoiceLineItem(): void {
      const newLineItems = this.totalSelectedLineItems.filter(
        (i: SelectedLineItemOption) => i.value !== this.invoiceItemToEdit?.value
      )
      this.setTotalSelectedLineItems(newLineItems)
      this.recalculateAllCosts()
      this.setActiveModal('')
    },

    onDelete(item: SelectedLineItemOption): void {
      this.setInvoiceItemToEdit(item)
      this.setActiveModal('deleteInvoiceItem')
    }
  }
}
